<template>
  <div class="container" v-if="item">
    <h1>
      Edit Image
      <ez-modal-delete class="pull-right"
        btnClass="btn-sm"
        @deleteData="deleteData()">
      </ez-modal-delete>
    </h1>
    <hr>

    <div class="row">
      <div class="col">
        <img v-if="item && item.url" :src="item.url">
      </div>
      <div class="col">
        <ez-text-area-md v-model="item.description" rows="8">Description</ez-text-area-md>
      </div>
    </div>
    <br>
    <p class="text-center">
      <button type="button" class="btn btn-primary" @click="patchData()">Save</button>
      <router-link class="btn btn-secondary" :to="`/images`">Cancel</router-link>
    </p>
  </div>
</template>

<script>
import EzModalDelete from "@/components/shared/_VueEzModalDelete";
import EzTextAreaMd from "../shared/_VueEzTextAreaMd.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "../../lib/axios";

export default {
  name: "image-edit",
  components: {
    EzModalDelete,
    EzTextAreaMd
  },
  data() {
    return {
      errors: {}
    };
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      canEdit: "images/canEdit"
    }),
    ...mapState({
      user: state => state.session.user,
      item: state => state.images.current
    })
  },
  methods: {
    ...mapActions({
      imagesEdit: "images/edit",
      imagesUpdate: "images/update",
      imagesDestroy: "images/destroy"
    }),
    async getData() {
      try {
        await this.imagesEdit({ id: this.$route.params.id });
        if (this.canEdit) {
          this.$embers.pageData(this.item.name, this.item.summary);
        } else {
          this.$router.push({ path: `/404` });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async patchData() {
      try {
        if (this.item.file) {
          // GET s3 SIGNED PUT URL
          let s3key = this.$embers.s3Key(
            this.user._id,
            this.item.file.type.split("/")[1]
          );
          let signedUrlPut = await axios.post(`/s3/signedUrl`, {
            key: s3key,
            type: this.item.file.type
          });

          // UPLOAD IMAGE
          await this.$embers.uploadImage({
            signedRequest: signedUrlPut.data.signedRequest,
            file: this.item.file
          });

          this.item.key = s3key;
          this.item.size = this.item.file.size;
          this.item.type = this.item.file.type;
          this.item.url = signedUrlPut.data.url;
        }
        await this.imagesUpdate();
        this.$router.push({ path: `/images/${this.item._id}` });
      } catch (err) {
        console.error(err);
        this.errors = Object.assign({}, this.errors, err.response.data);
      }
    },
    async deleteData() {
      try {
        await this.imagesDestroy();
        this.$router.push({ path: `/images` });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
